



export default function ThankYou() {
    return (
        <>
            <style>
                {`
                body{
                background: linear-gradient(119deg, rgba(130, 217, 227, 1) 15%, rgba(74, 199, 217, 1) 54%, rgba(38, 188, 209, 1) 100%);
                }
                
                    * {
                        margin: 0;
                        padding: 0;
                        box-sizing: border-box;
                    }

                    .wrapper-1 {
                        width: 100%;
                        height: 100vh;
                        display: flex;
                        flex-direction: column;
                        border: 2px solid #80808054;
                        border-radius: 7px 150px 7px 7px;
                        background-color: #ffffff57;
                    }

                    .wrapper-2 {
                        padding: 30px;
                        text-align: center;
                        padding-bottom: 20px;
                    }

                    h1 {
                        font-size: 4em;
                        letter-spacing: 3px;
                        color: #000;
                        margin: 0;
                        margin-bottom: 20px;
                    }

                    .wrapper-2 p {
                        margin: 0;
                        font-size: 1.3em;
                        color: #000;
                        font-family: "Montserrat", serif;
                        letter-spacing: 1px;
                    }

                    .wrapper-2 img {
                        padding: 10px 15px;
                        border-radius: 10px;
                        width: 300px;
                    }

                    .go-home {
                        color: #000;
                        backgroundcolor: #fff
                        border: none;
                        padding: 10px 50px;
                        font-weight: 700;
                        margin: 30px 0;
                        border-radius: 30px;
                        text-transform: capitalize;
                    }

                    @media (min-width:360px) {
                        h1 {
                            font-size: 3.5em;
                        }
                        .go-home {
                            margin-bottom: 20px;
                        }
                    }

                    @media (min-width:600px) {
                        .content {
                            max-width: 1000px;
                            margin: 0 auto;
                        }
                        .wrapper-1 {
                            height: initial;
                            max-width: 620px;
                            margin: 0 auto;
                            margin-top: 50px;
                            box-shadow: 4px 8px 40px 8px rgba(255, 255, 255, 0.2);
                        }
                    }

                    @media (max-width: 575.98px) {
                        br {
                            display: none;
                        }
                        .wrapper-1 {
                            width: 100%;
                            height: 50vh;
                            margin-top: 200px;
                        }
                    }

                    @media (min-width: 768px) and (max-width: 991.98px) {
                        .wrapper-1 {
                            height: initial;
                            max-width: 620px;
                            margin: 0 auto;
                            margin-top: 300px;
                            box-shadow: 4px 8px 40px 8px rgba(255, 255, 255, 0.2);
                        }
                    }
                `}
            </style>
            <div style={{

                background: 'linear-gradient(119deg, rgba(130, 217, 227, 1) 15%, rgba(74, 199, 217, 1) 54%, rgba(38, 188, 209, 1) 100%)',
                backgroundSize: '100%',
                backgroundPosition: 'top center'
            }}> 
                <div className="content">
                    <div className="wrapper-1">
                        <div className="wrapper-2">
                            <img className="my-1 logo-img" src="assets/images/logo.svg" alt="logo-img" width="155" />
                            <h1>Thank you !</h1>
                            <p>Thanks for submitting to our register form. </p>
                            <p>Your message has been successfully submitted. Thank you for reaching out to us! </p>
                            <a href="/">
                                <button className="go-home" onClick={() => window.location.href = '/'}>
                                    Return to Home
                                </button>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}